module.exports = __webpack_public_path__ + "static/img/viphub_banner.a009740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/viphub_banner.png
// module id = /VNt
// module chunks = 1